import request from "@/utils/requestToTrackingServer";

export function saveEvent(context, name) {
  const video_id = context.rootState.brandChannel.tape.video_id;
  const session_id = window.__ovmSID;

  if (typeof session_id === "undefined") {
    console.error("tracking/saveEvent called without SessionID!");
    return false;
    // throw new Error("No SessionID error"); // pq não funciona?!??!
  }

  if (typeof video_id === "undefined") {
    console.warn("tracking/saveEvent called without VideoID!");
  }

  const event = {
    name,
    video_id,
    session_id,
    timestamp: new Date().toISOString()
  };

  const user_id = context.rootState.brandChannel.tape.ovmConfig.env.user_id;
  if (user_id !== "undefined") {
    event.client_viewer_id = user_id;
  }

  return request({
    url: "/events/save",
    method: "post",
    data: event
  });
}
